module.exports = __webpack_public_path__ + "static/media/bg@1x.bb9867b6.png";